import { useMemo } from 'react';
import { createAutocompleteMyType } from '../types';
import useReshape from './use-reshape';
import useGetSources from './use-get-sources';
import useSyncState from './use-sync-state';
export default function useAutocomplete(clients, context, onSubmit) {
  const getSources = useGetSources(clients, context);
  const reshape = useReshape(context);
  const {
    autocompleteState,
    onStateChange,
    resetState
  } = useSyncState();
  const autocomplete = useMemo(() => createAutocompleteMyType({
    getSources,
    reshape,
    onStateChange,
    onSubmit,
    openOnFocus: true
  }), [getSources, reshape, onStateChange, onSubmit]);
  return {
    autocomplete,
    autocompleteState,
    resetState
  };
}